/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum PortalFiltersIds {
    PortalFiltersSection = 'portalFiltersSection',
    SitesPortalFilter = 'sitesPortalFilter',
    OrganizationsPortalFilter = 'organizationsPortalFilter',
    LocationsPortalFilter = 'locationsPortalFilter',
}
